import { PatientTab } from '@lmt/unicorn-shared/app/components/patients/profile/types';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC } from 'react';

import styles from './PatientNavTab.module.scss';

interface Props {
  title: PatientTab;
  isSelected: boolean;
  onClick: (title: string) => void;
}

export const PatientNavTab: FC<Props> = (props) => {
  const { title, isSelected, onClick } = props;
  const i18n = useScopedTranslation('patients.tabs');
  return (
    <div
      className={styles.tab}
      data-selected={isSelected}
      data-test-id={'patient_tab_' + title}
      onClick={() => !isSelected && onClick(title)}
    >
      <div className={styles.title}>{i18n.t(props.title)}</div>
      <div data-selected={isSelected} className={styles.underline}>
        {' '}
      </div>
    </div>
  );
};
